import { equals, filter } from "ramda";

import {
  posUserHasPhone,
  posUserHasEmail,
} from "helpers/schedule/scheduling_page";
import { IPosUser } from "types/schedules";

// Component Reducer
enum IPosUserUUIDStatus {
  SELECTED,
  DESELECTED,
  DISABLED,
}
interface IPosUserUUIDState {
  selection: {
    [key: string]: IPosUserUUIDStatus;
  };
  uuidsWithPhone: Set<string>;
  uuidsWithEmail: Set<string>;
  canSms: boolean;
  canEmail: boolean;
}

function initPosUserState(posUsers: IPosUser[]): IPosUserUUIDState {
  return posUsers.reduce(
    (state: IPosUserUUIDState, posUser: IPosUser) => {
      const hasPhone = posUserHasPhone(posUser);
      const hasEmail = posUserHasEmail(posUser);
      if (hasPhone || hasEmail) {
        state.selection[posUser.uuid] = IPosUserUUIDStatus.SELECTED;
        if (hasPhone) {
          state.uuidsWithPhone.add(posUser.uuid);
          state.canSms = true;
        }
        if (hasEmail) {
          state.uuidsWithEmail.add(posUser.uuid);
          state.canEmail = true;
        }
      } else {
        state.selection[posUser.uuid] = IPosUserUUIDStatus.DISABLED;
      }
      return state;
    },
    {
      selection: {},
      uuidsWithPhone: new Set(),
      uuidsWithEmail: new Set(),
      canSms: false,
      canEmail: false,
    }
  );
}

function reducer(state: IPosUserUUIDState, uuid: string) {
  const newStatus =
    state.selection[uuid] === IPosUserUUIDStatus.DESELECTED
      ? IPosUserUUIDStatus.SELECTED
      : IPosUserUUIDStatus.DESELECTED;
  const selection = { ...state.selection, [uuid]: newStatus };
  const newState = { ...state, selection };

  const selectedIds = getSelectedUUIds(newState);
  const canEmail = selectedIds.some(id => state.uuidsWithEmail.has(id));
  const canSms = selectedIds.some(id => state.uuidsWithPhone.has(id));
  return {
    ...newState,
    canEmail,
    canSms,
  };
}

const filterIsSelected = filter(equals(IPosUserUUIDStatus.SELECTED));
function getSelectedUUIds(state: IPosUserUUIDState): string[] {
  return Object.keys(filterIsSelected(state.selection));
}

export {
  initPosUserState,
  reducer,
  getSelectedUUIds,
  IPosUserUUIDStatus,
  IPosUserUUIDState,
};
